import { initialState } from '../state';
import { UpdatePatientDataInStoreAction, PatientDataActionTypes } from '../../store/actions';

export function patientData(state = initialState.patientData, action: UpdatePatientDataInStoreAction): any {
  switch (action.type) {
    case PatientDataActionTypes.UPDATE_PATIENT_DATA_IN_STORE: {
      return Object.assign({ }, state, action.payload.patientData);
    }
    default: {
      return state;
    }
  }
}

